document.addEventListener('change', function(e) {
    let klass = '.table-mobile-input';
    let target = e.target.closest(klass);
    if(target) {
        let input = document.querySelector('.table-desktop-input');
        if(input) {
            input.checked = target.checked;
        }
    }
});